export const API_URL = 'http://localhost:3000/';
export const URL_API = 'https://oauth.reddit.com';
export const URL_AUTH = 'https://www.reddit.com/api/v1/authorize?';
export const CLIENT_ID = 'aQLz8miEW0A5T6AN0xATBg';
export const RESPONSE_TYPE = 'token';
export const RANDOM_STRING = 'random_string';
export const REDIRECT_URI = 'https://blogget-build.vercel.app/auth';
export const SCOPE = 'identity submit read';


